import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app/App";
import { initMonitoring } from "./app/lib/monitoring";
import { initViewportPanFix } from "./app/lib/viewportPanFix";
import { installChunkRecovery } from "./app/lib/chunkRecovery";
import "./styles/index.css";

// Initialise error monitoring before the app renders so early crashes are caught.
initMonitoring();
// Reload onto the current build when a deploy retires the chunks this tab was
// loaded with, instead of leaving navigation permanently broken.
installChunkRecovery();
// Undo iOS's stuck keyboard viewport pan (fixed elements drifting off-screen
// in the installed PWA). Registered at boot so the sign-in screen is covered.
initViewportPanFix();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

